/** Apex tooltips — avoid theme:"dark" + global SCSS (white box, invisible text). */
export function dashApexTooltip(extra = {}) {
  const base = {
    enabled: true,
    theme: "light",
    shared: false,
    intersect: false,
    fillSeriesColor: false,
    style: {
      fontSize: "12px",
      fontFamily: "inherit",
    },
    marker: {
      show: true,
    },
    x: {
      show: true,
      formatter(val) {
        return val != null && val !== "" ? String(val) : "";
      },
    },
    y: {
      formatter(val) {
        if (val == null || Number.isNaN(Number(val))) return "—";
        return `Rs. ${Number(val).toLocaleString()}`;
      },
      title: {
        formatter(seriesName) {
          return seriesName || "Amount";
        },
      },
    },
  };
  return { ...base, ...extra, x: { ...base.x, ...(extra.x || {}) }, y: { ...base.y, ...(extra.y || {}), title: { ...base.y.title, ...(extra.y && extra.y.title ? extra.y.title : {}) } } };
}

export function dashApexTooltipShared() {
  return dashApexTooltip({
    shared: true,
    intersect: false,
  });
}

/** Horizontal bar: fee type as title, amount as value. */
export function dashApexTooltipHorizontalBar(categories = []) {
  const cats = Array.isArray(categories) ? categories : [];
  return {
    enabled: true,
    theme: "light",
    intersect: true,
    shared: false,
    fillSeriesColor: false,
    custom({ series, seriesIndex, dataPointIndex, w }) {
      const label =
        cats[dataPointIndex] ||
        (w.globals.labels && w.globals.labels[dataPointIndex]) ||
        (w.globals.categoryLabels &&
          w.globals.categoryLabels[dataPointIndex]) ||
        "Fee";
      const raw = series[seriesIndex][dataPointIndex];
      const amount =
        raw != null && !Number.isNaN(Number(raw))
          ? Number(raw).toLocaleString()
          : "0";
      return (
        '<div class="dash-apex-tip">' +
        `<div class="dash-apex-tip__title">${escapeHtml(label)}</div>` +
        `<div class="dash-apex-tip__row">` +
        `<span class="dash-apex-tip__label">Amount</span>` +
        `<span class="dash-apex-tip__value">Rs. ${amount}</span>` +
        `</div></div>`
      );
    },
  };
}

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
